import { Dispatch, memo, SetStateAction, useMemo } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import { FiSearch } from "react-icons/fi";
import TextInput from "@components/TextInput";
import SlashSelect from "@components/SlashSelect";
import { containsAll, getUnique, containsSome, getDifference } from "@core/utils/array";
import { useSelectedKeywordsContext } from "@vms/SelectedKeywords/SelectedKeywordsContext";
import { VisualizeDataItem } from "@api/useVisualizeData";

const VisualizeTableFilters: FCX<{
    search: string;
    setSearch: Dispatch<SetStateAction<string>>;
    filteredResultsIds: VisualizeDataItem['id'][];
}> = ({
    search,
    setSearch,
    filteredResultsIds,
}) => {
    const {
        selectedKeywordsIds,
        setSelectedKeywordsIds,
        isSelectedKeywordsView,
    } = useSelectedKeywordsContext();

    const slashSelectData = useMemo(
        () => {
            return [
                {
                    title: "Select All",
                    isActive: containsAll(selectedKeywordsIds, filteredResultsIds),
                    onClick: () => setSelectedKeywordsIds(getUnique([
                        ...selectedKeywordsIds,
                        ...filteredResultsIds,
                    ])),
                },
                {
                    title: "Clear All",
                    isActive: !containsSome(selectedKeywordsIds, filteredResultsIds),
                    onClick: () => setSelectedKeywordsIds(getDifference(selectedKeywordsIds, filteredResultsIds)),
                },
            ];
        },
        [selectedKeywordsIds, setSelectedKeywordsIds, filteredResultsIds]
    );

    return (
        <div className="VisualizeTableFilters">
            <TextInput
                className="VisualizeTableFilters__search appears-left"
                placeholder="search an item"
                testId="blockVisualizeSearchFilter"
                prefix={<FiSearch/>}
                value={search}
                setValue={setSearch}
            />
            {!isSelectedKeywordsView && (
                <SlashSelect
                    className="VisualizeTableFilters__slash-select"
                    data={slashSelectData}
                    testId="blockFiltersExpandCollapse"
                />
            )}
        </div>
    )
}

export default memo(VisualizeTableFilters);